class PatternsFound{
    patterns = [];
    add(pattern){     
        
        if(this.patterns.some(p=>p===pattern)) return;

        this.patterns = [...this.patterns,pattern];
    }
    exists(pattern){
        return this.patterns.some(p=>p===pattern);
    }
    addMany(patterns){

        const nonExistingPatterns = patterns.filter(p=>!this.patterns.some(p1=>p1===p));

        this.patterns = [...this.patterns,...nonExistingPatterns];
    }
    remove(pattern){
        this.patterns = this.patterns.filter(p=>p!==pattern);
    }
    removeMany(patterns){
        for(let pattern in patterns){
            this.remove(pattern);
        }
    }
    clear(){
        this.patterns = [];
    }
}

export const patternsFoundSingleton = new PatternsFound();